"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwoFactorAttemptsExhaustedViewContainer = TwoFactorAttemptsExhaustedViewContainer;
var React = _interopRequireWildcard(require("react"));
var _events = require("../../types/events");
var _validation = require("../../utils/validation");
var _ViewContainer = require("../ViewContainer");
var _TitleContainer = require("../TitleContainer");
var _SubtitleLayout = require("../../components/SubtitleLayout");
var _TwoFactorAttemptsExhausted = require("../../components/TwoFactorAttemptsExhausted");
var _tracking = require("../../utils/tracking");
var _authentication = require("../../types/authentication");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function TwoFactorAttemptsExhaustedViewContainer(_ref) {
  let {
    login,
    phone,
    changeLogin,
    reset,
    emit
  } = _ref;
  const contactQuery = React.useMemo(() => [(0, _validation.isEmail)(login) ? `email=${encodeURIComponent(login)}` : null, phone && (0, _validation.isValidPhone)(phone) ? `phone=${encodeURIComponent(`+${phone.replace(/\D+/g, '')}`)}` : null, 'twoFactor=true'].filter(Boolean).join('&'), [login, phone]);
  const handleSupportClick = React.useCallback(() => {
    emit(_events.EEventType.TwoFactorAttemptsExhaustedSupportClick);
    (0, _tracking.trackTwoFactorAttemptsExhaustedSupportClick)(phone ? _authentication.ETwoFactorType.Phone : _authentication.ETwoFactorType.Email);
    window.open(`/contacts/?${contactQuery}`, '_blank');
  }, [contactQuery, emit, phone]);
  const handleBackClick = React.useCallback(() => {
    reset();
    changeLogin(login);
  }, [changeLogin, login, reset]);
  return /*#__PURE__*/React.createElement(_ViewContainer.ViewContainer, null, /*#__PURE__*/React.createElement(_TitleContainer.TitleContainer, null), /*#__PURE__*/React.createElement(_SubtitleLayout.SubtitleLayout, {
    offset: _SubtitleLayout.ESubtitleOffset.XL
  }, "\u041F\u0440\u0435\u0432\u044B\u0448\u0435\u043D\u043E \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u0435 \u043D\u0430 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043F\u043E\u043F\u044B\u0442\u043E\u043A \u0432\u0432\u043E\u0434\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043E\u0447\u043D\u043E\u0433\u043E \u043A\u043E\u0434\u0430. \u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u0432 \u0441\u043B\u0443\u0436\u0431\u0443 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0438 \u0434\u043B\u044F \u0440\u0435\u0448\u0435\u043D\u0438\u044F \u044D\u0442\u043E\u0439 \u043F\u0440\u043E\u0431\u043B\u0435\u043C\u044B."), /*#__PURE__*/React.createElement(_TwoFactorAttemptsExhausted.TwoFactorAttemptsExhausted, {
    onSupport: handleSupportClick,
    onCancel: handleBackClick
  }));
}